<template>
  <div>
    <div class="header">
      <van-notice-bar
        background="#009fff"
        color="white"
        left-icon="volume-o"
        text="添加卡时，请仔细核对卡号,备注信息最多只能输入8个文字。"
      />
    </div>
    <div class="detail">
      <div>
        <p style="font-size: 16px; text-align: left">卡号：</p>
        <van-cell-group
          style="
            box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
            border-radius: 20px;
          "
        >
          <van-field
            style="border-radius: 20px"
            v-model="card2"
            placeholder="请输入卡号"
          />
        </van-cell-group>
      </div>

      <div style="margin: 20px 0">
        <p style="font-size: 16px; text-align: left">备注：</p>
        <van-cell-group
          style="
            box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
            border-radius: 20px;
          "
        >
          <van-field
            style="border-radius: 20px"
            v-model="remark"
            maxlength="8"
            placeholder="请输入备注"
          />
        </van-cell-group>
      </div>

      <van-button style="width: 100%" round type="info" @click="add">
        确认添加
      </van-button>
    </div>
  </div>
</template>

<script>
  import { addCardSave } from "../api/cardOperation";
  export default {
    name: "AddCard",
    data: function () {
      return {
        card2: "",
        remark: "",
      };
    },
    created() {},
    methods: {
      add() {
        addCardSave({
          card: localStorage.getItem("meCardNum"),
          card2: this.card2,
          remark: this.remark,
        }).then((res) => {
          if (res.status) {
            this.$notify({ type: "success", message: res.msg });
            this.$router.push("/switch");
          } else {
            this.$notify({ type: "warning", message: res.msg });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header {
    background-color: #009fff;
  }
  .detail {
    padding: 20px;

    box-sizing: border-box;
  }
</style>
